export const INTEGRATIONS_DOMAIN = 'integrations' as const;

export const integrationsDomainDescription = `The configure step of a tabular import (Excel, JSON, ServiceNow, Jira and similar), where the user sets up each
  table of the import: whether rows become components or references, which workspaces to import into, and how columns map to
  components, fields, parents and references. Delegate to handle_ui_command when the user asks to map, automap or
  suggest mappings for the tables.`;
